import { makeStyles } from '@material-ui/core/styles';
import { getScrollbarStyles } from '../../../../materialConfig/commonStyles';

// @ts-ignore
export const useStyles = makeStyles((theme) => ({
  formGroups: {
    marginTop: '20px',
  },
  formGroup: {
    display: 'grid',
    gridGap: '20px',
    gridAutoRows: 'max-content',
  },
  submitSection: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gridTemplateColumns: 'max-content minmax(100px, 200px)',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      gridGap: '20px',
    },
  },
  available: {
    padding: '23px',
  },
  formRowN: {
    display: 'grid',
    gridGap: '20px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  dateRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dateN: {
    minWidth: '490px',
    display: 'grid',
    gridGap: '5px',
    alignItems: 'end',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
    '@media (max-width: 1366px)': {
      minWidth: '450px',
    },
    '@media (max-width: 1106px)': {
      minWidth: '350px',
    },
    '@media (max-width: 960px)': {
      minWidth: '250px',
    },
    '@media (max-width: 700px)': {
      minWidth: '150px',
    },
  },
  date: {
    display: 'grid',
    gridGap: '20px',
    alignItems: 'end',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  gray: {
    margin: '0',
    color: '#9EA8AB',
  },
  image: {
    height: '140px',
    width: '140px',
    margin: '5px 0 20px 0',
  },
  FW: {
    fontWeight: 500,
  },
  related_media: {
    marginBottom: '10px',
  },
  modalBoxSizing: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: '#FFFFFF',
    boxShadow: '8px 8px 12px rgba(0, 0, 0, 0.02)',
    borderRadius: '16px',
  },
  modalBoxSizingRelatedMedia: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  modalBoxSizingView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '32px',
    paddingRight: '32px',
    position: 'absolute',
    width: '30%',
    height: '250px%',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FFFFFF',
    boxShadow: '8px 8px 12px rgba(0, 0, 0, 0.02)',
    borderRadius: '16px',
    '@media (max-width:720px)': {
      width: '335px',
      height: '304px',
      left: '50%',
      top: '50%',
    },
  },
  span: {
    position: 'absolute',
    right: '2%',
    cursor: 'pointer',
    background: '#FFFFFF',
    fontWeight: 400,
    fontSize: '30px',
    marginBottom: '10px',
  },
  btnSubmit: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 24px',
    position: 'static',
    width: '105px',
    height: '48px',
    left: '32px',
    top: '208px',
    background: '#77CC21',
    borderRadius: '8px',
    flex: 'none',
    margin: '24px 0px',
    color: '#FFFFFF',
    '@media (max-width:720px)': {
      width: '271px',
    },
  },
  TypographyModal: {
    ...getScrollbarStyles(),
    width: '-webkit-fill-available',
    position: 'static',
    margin: '15px 0px',
    fontSize: 'large',
    fontWeight: '600',
    maxHeight: 'calc(100vh - 210px)',
    overflowY: 'auto',
  },
  button: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 102px',
    border: '1px solid #EBEBEB',
    boxSizing: 'border-box',
    borderRadius: '2px',
    margin: '5px 0px',
    width: '200px',
    height: '45px',
  },
  modal: {
    display: 'flex',
    gridGap: '10px',
    marginTop: '35px',
    gridTemplateColumns: '1fr 1fr',
    alignContent: 'flex-end',
    justifyItems: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
  related_mediaBox: {
    display: 'grid',
    gridTemplateColumns: '50px 1fr 20px',
    gridGap: '15px',
    alignItems: 'center',
    width: '100%',
  },
  mediaImage: {
    maxHeight: '50px',
  },
  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  oneCard: {
    maxWidth: '174px',
    margin: '0px 20px 50px 0px',
  },
  heading: {
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '140%',
    minHeight: '45px',
    marginTop: '10px',
  },
}));
